import Vue from "vue";
import { $eventsBus } from "@/main";
import Vuex from "vuex";
import _ from "lodash";
import { Item } from "@/app/modules/work/models/classes/Item";
import { ItemVariation } from "@/app/modules/work/models/classes/ItemVariation";
import axios from "axios";
Vue.use(require("vue-cookies"));

Vue.use(Vuex);

class UndoRedoHistory {
  store;
  history = [];
  currentIndex = -1;

  init(store) {
    this.store = store;
  }

  addState(state) {
    // may be we have to remove redo steps
    if (this.currentIndex + 1 < this.history.length) {
      this.history.splice(this.currentIndex + 1);
    }
    this.history.push(state);
    this.currentIndex++;
  }

  updateCurrentState(state) {
    this.history[this.currentIndex] = state;
  }

  undo() {
    if (!this.canUndo) {
      return;
    }
    const prevState = this.history[this.currentIndex - 1];
    // take a copy of the history state
    // because it would be changed during store mutations
    // what would corrupt the undo-redo-history
    // (same on redo)
    this.store.replaceState(_.cloneDeep(prevState));
    this.currentIndex--;
  }

  redo() {
    if (!this.canRedo) {
      return;
    }
    const nextState = this.history[this.currentIndex + 1];
    this.store.replaceState(_.cloneDeep(nextState));
    this.currentIndex++;
  }

  canUndo() {
    return this.currentIndex !== 0 && this.currentIndex !== -1;
  }

  canRedo() {
    return this.history.length !== this.currentIndex + 1;
  }
}

const undoRedoHistory = new UndoRedoHistory();
Vue.prototype.$undoRedoHistory = Vue.observable(undoRedoHistory);

const undoRedoPlugin = (store) => {
  // initialize and save the starting stage
  undoRedoHistory.init(store);
  let firstState = _.cloneDeep(store.state);
  undoRedoHistory.addState(firstState);

  store.subscribe((mutation, state) => {
    // is called AFTER every mutation
    switch (mutation.type) {
      case "undo":
        undoRedoHistory.undo();
        return;
      case "redo":
        undoRedoHistory.redo();
        return;
      case "addNewStateToHistory":
        //проверка, что произошли изменения
        if (
          JSON.stringify(
            undoRedoHistory.history[undoRedoHistory.currentIndex]
          ) !== JSON.stringify(state)
        ) {
          undoRedoHistory.addState(_.cloneDeep(state));
        }
        return;
      case "contentVideoCurrentTime":
      case "showOverlaysLibraryWindow":
      case "showEndCardCropImageWindow":
        return;
      default:
        undoRedoHistory.updateCurrentState(_.cloneDeep(state));
        return;
    }
  });
};

export const store = new Vuex.Store({
  plugins: [undoRedoPlugin],
  state: {
    //User
    userInfo: {
      sessionId: Vue.$cookies.get("sessionId"),
      id: -1,
      firstName: "",
      lastName: "",
      avatar: "",
      stockAccess: false,
      isSaveOriginalName: true,
      lastWorkspaceSaveTime: null,
      isInHouse: false,
    },
    userWorkParameters: {
      enableSlicerByDefault: null,
      wasShownAndClosedNoticeSharpen: false,
    },
    defaultVariationNamingTemplate: [
      {
        id: "custom_initial_id",
        name: "custom",
        title: "Custom",
        value: "1",
      },
      {
        id: "version",
        name: "version",
        title: "Version",
        value: {
          id: 0,
          name: `"v" + %index%`,
          title: `v1,v2,... by Item`,
        },
      },
      {
        id: "size",
        name: "size",
        title: "Size",
        value: {
          id: 2,
          name: `%f/s/h/p/v%`,
          title: `Symbol`,
        },
      },
      {
        id: "duration",
        name: "duration",
        title: "Duration",
        value: {
          id: 1,
          name: `%duration% + "s"`,
          title: `Duration + s`,
        },
      },
      {
        id: "language",
        name: "language",
        title: "Language",
        value: { id: "WW", name: "WW", title: "WW", fullName: "World wide" },
      },
    ],
    variationNamingTemplate: [],
    videoPreviewPixelsWidth: 0,
    contentVideoCurrentTime: 0,
    copiedVariationSettings: null,
    //Files
    filesToUpload: [],
    tasksFromUAToUpload: [],
    //Items
    items: [],
    renderItems: [],
    deletedObjects: [],
    selectedItem: null,
    //Boolean parameters
    uploadToCloud: false,
    muted: true,
    showDownloadPanel: false,
    showRendersPreviewWindow: false,
    showMusicLibraryWindow: false,
    showEndCardLibraryWindow: false,
    showEndCardEditWindow: false,
    showStickerLibraryWindow: false,
    showOverlaysLibraryWindow: false,
    showEndCardCropImageWindow: false,
    openedGridType: 'none',
    snapshot: null,
    recentImages: [],
    recentMusics: [],
    overlaysLibrary: {
      images: [],
      videos: [],
      shapes: [],
    },
    musicLibrary: {
      files: [],
    },
    overlayGrids: {
      tiktok: null,
      instagramStories: null,
    }
  },
  mutations: {
    undo(state) {},
    redo(state) {},
    addNewStateToHistory(state, isCloseAllWindowsBeforeSave) {
      if (isCloseAllWindowsBeforeSave) {
        state.showOverlaysLibraryWindow = false;
        state.showEndCardCropImageWindow = false;
      }
    },
    //User workspace from server
    updateStateByUserWorkspace(state, savedState) {
      if (savedState.defaultVariationNamingTemplate) {
        state.defaultVariationNamingTemplate =
          savedState.defaultVariationNamingTemplate;
      } else {
        if (!state.userInfo.isInHouse) {
          state.defaultVariationNamingTemplate = [
            {
              id: "originalName",
              name: "originalName",
              title: "Original Name",
              value: "",
            },
          ];
        }
      }

      if (savedState.userWorkParameters) {
        state.userWorkParameters = savedState.userWorkParameters;

        if (!savedState?.userWorkParameters?.wasShownAndClosedNoticeSharpen) {
          state.userWorkParameters.wasShownAndClosedNoticeSharpen = false;
        }
      }

      if (savedState.variationNamingTemplate) {
        state.variationNamingTemplate = savedState.variationNamingTemplate;
      } else {
        state.variationNamingTemplate = state.defaultVariationNamingTemplate.slice();
      }
      if (savedState.items) {
        state.items = [
          ...savedState.items
            .map((parsedItem) => {
              if (
                !!parsedItem &&
                (!parsedItem.loadingParameters ||
                  parsedItem.loadingParameters.loaded)
              ) {
                let newItem = Item.copyFromParsed(parsedItem);
                newItem.variations.forEach((v) => {
                  if (v.outputNameTemplate === null) {
                    v.outputNameTemplate = JSON.parse(
                      JSON.stringify(state.variationNamingTemplate)
                    );
                  }
                });
                return newItem;
              }
            })
            .filter((i) => !!i),
        ];
      }

      if (savedState.renderItems) {
        state.renderItems = savedState.renderItems;
      }
      state.selectedItem = state.items.length !== 0 ? state.items[0] : null;

      //state.muted = savedState.muted;
      state.showDownloadPanel = !!savedState.showDownloadPanel;
      state.recentImages = !savedState?.recentImages
        ? []
        : savedState?.recentImages.map((i) => {
            return { ...i, isPlug: true };
          });
      state.recentMusics = !savedState?.recentMusics
        ? []
        : savedState?.recentMusics.map((i) => {
            return { ...i };
          });
    },
    videoPreviewPixelsWidth(state, videoPreviewPixelsWidth) {
      state.videoPreviewPixelsWidth = videoPreviewPixelsWidth;
    },
    contentVideoCurrentTime(state, contentVideoCurrentTime) {
      state.contentVideoCurrentTime = contentVideoCurrentTime;
    },
    renderItems(state, renderItems) {
      state.renderItems = renderItems;
    },
    variationNamingTemplate(state, variationNamingTemplate) {
      state.variationNamingTemplate = variationNamingTemplate;
    },
    copiedVariationSettings(state, copiedVariationSettings) {
      state.copiedVariationSettings = copiedVariationSettings;
    },
    defaultVariationNamingTemplate(state, defaultVariationNamingTemplate) {
      state.defaultVariationNamingTemplate = defaultVariationNamingTemplate;
    },

    //Files
    updateFilesToUpload(state, files) {
      state.filesToUpload = files;
    },
    updateTasksFromUAToUpload(state, tasks) {
      state.tasksFromUAToUpload = tasks;
    },
    //Items
    itemsUploaded(state, data) {
      let isStartUploading = state.items.length === 0;

      data.forEach((uploadedFile) => {
        if (uploadedFile.type !== "video") {
          return;
        }
        let item = new Item();

        item.loadingParameters.loaded = true;
        item.loadingParameters.process = 100;
        item.loadingParameters.uploadedType = !!uploadedFile.fromUA ? 3 : 4;

        item.fileId = uploadedFile.fileId;
        item.name = uploadedFile.name;
        item.src = uploadedFile.file;
        item.isOutsize = uploadedFile.R.length === 2;
        item.inputSize = JSON.parse(
          JSON.stringify(Item.getVideoSize(uploadedFile.R))
        );

        item.fps = uploadedFile.fps;
        item.duration = uploadedFile.duration;
        item.size = uploadedFile.size;
        item.bitrate = uploadedFile.bitrate;
        if (!!uploadedFile.thumbs) {
          item.thumbs = uploadedFile.thumbs;
        }

        item.innerVideoResolutionX = parseInt(uploadedFile.resolution_x);
        item.innerVideoResolutionY = parseInt(uploadedFile.resolution_y);

        item.isForSlice =
          !!state.userWorkParameters.enableSlicerByDefault &&
          item.innerVideoResolutionX === 1920 &&
          item.innerVideoResolutionY === 1920;
        item.isFromUA = !!uploadedFile.fromUA;

        if (item.isForSlice) {
          Item.videoSizes.forEach((size) =>
            item.addNewVariation(
              state.userInfo.isSaveOriginalName,
              JSON.parse(JSON.stringify(state.variationNamingTemplate)),
              size.name
            )
          );
        } else {
          item.addNewVariation(
            state.userInfo.isSaveOriginalName,
            JSON.parse(JSON.stringify(state.variationNamingTemplate))
          );
        }

        if (isStartUploading) {
          state.items.push(item);
        } else {
          state.items.push(item);
        }
        if (item.isForSlice) {
          $eventsBus.$emit("openSideMenuItem", item);
        }
      });
      if (isStartUploading) {
        state.selectedItem = state.items[0];
      }
    },
    updateItemsAfterUpload(state, data) {
      data.files.forEach((uploadedFile) => {
        /* if (uploadedFile.type !== "video") {
					return;
				} */
        let item = state.items.find(
          (i) => i.loadingParameters.uploadingId === data.uploadingId
        );
        if (!item) {
          return;
        }

        item.loadingParameters.loaded = true;
        item.loadingParameters.process = 100;

        item.fileId = uploadedFile.fileId;
        item.name = uploadedFile.name;
        item.src = uploadedFile.file;
        item.isOutsize = uploadedFile.R.length === 2;
        item.inputSize = JSON.parse(
          JSON.stringify(Item.getVideoSize(uploadedFile.R))
        );

        item.fps = uploadedFile.fps;
        item.duration = Math.round(uploadedFile.duration * 1000) / 1000;
        item.size = uploadedFile.size;
        item.bitrate = uploadedFile.bitrate;
        if (!!uploadedFile.thumbs) {
          item.thumbs = uploadedFile.thumbs;
        }

        item.innerVideoResolutionX = parseInt(uploadedFile.resolution_x);
        item.innerVideoResolutionY = parseInt(uploadedFile.resolution_y);
        item.isForSlice =
          !!state.userWorkParameters.enableSlicerByDefault &&
          item.innerVideoResolutionX === 1920 &&
          item.innerVideoResolutionY === 1920;
        item.isFromUA = !!uploadedFile.fromUA;

        let parentItem = item.parseToShortObject();
        item.variations.forEach((v) => {
          v.parentItem = parentItem;
          v.recalcFileOutputParameters();
        });
      });
    },
    setItems(state, items) {
      state.items = [...items];
    },
    deleteItem(state, item) {
      state.items.splice(state.items.indexOf(item), 1);
      if (state.selectedItem === item && state.items.length === 0) {
        state.selectedItem = null;
      } else {
        //TODO понять почему иначе смена не происходит
        setTimeout(() => {
          state.selectedItem = state.items[0];
        }, 50);
      }
    },
    undoDeleteObjects(state) {
      /* 			let lastIndex = state.deletedObjects.length - 1;
						if (lastIndex === -1) {
							return;
						}
						state.deletedObjects[lastIndex].forEach(o => {
							if (o instanceof Item) {
								state.items.push(o)
							} else if (o instanceof ItemVariation) {
								o.parentItem.variations.push(o);
								if (o.parentItem.variations.every((v) => v.checked)) {
									o.parentItem.checked = true;
								} else {
									o.parentItem.checked = false;
								}
							}
						});
						state.deletedObjects.splice(lastIndex, 1);
						if (state.selectedItem === null) {
							state.selectedItem = state.items[0];
						} */
    },
    changeSelectItem(state, item) {
      state.selectedItem = item;
    },
    uploadToCloud(state, isUploadToCloud) {
      state.uploadToCloud = isUploadToCloud;
    },
    muted(state, isMuted) {
      state.muted = isMuted;
    },
    //Boolean parameters
    showDownloadPanel(state, isShow) {
      state.showDownloadPanel = isShow;
    },
    showRendersPreviewWindow(state, isShow) {
      state.showRendersPreviewWindow = isShow;
    },
    showMusicLibraryWindow(state, isShow) {
      state.showMusicLibraryWindow = isShow;
    },
    showEndCardLibraryWindow(state, isShow) {
      state.showEndCardLibraryWindow = isShow;
    },
    showEndCardEditWindow(state, isShow) {
      state.showEndCardEditWindow = isShow;
    },
    showStickerLibraryWindow(state, isShow) {
      state.showStickerLibraryWindow = isShow;
    },
    showOverlaysLibraryWindow(state, isShow) {
      state.showOverlaysLibraryWindow = isShow;
    },
    showEndCardCropImageWindow(state, isShow) {
      state.showEndCardCropImageWindow = isShow;
    },
    setSnapshot(state, currentState) {
      state.snapshot = { ...currentState };
    },
    pushImageToOverlaysLibrary(state, file) {
      state.overlaysLibrary = {
        ...state.overlaysLibrary,
        images: [...state.overlaysLibrary.images, file],
      };
    },
    unshiftImageToOverlaysLibrary(state, file) {
      state.overlaysLibrary = {
        ...state.overlaysLibrary,
        images: [file, ...state.overlaysLibrary.images],
      };
    },
    updateImageInOverlaysLibrary(state, obj) {
      state.overlaysLibrary.images.find((item) => item === obj.file)[
        Object.keys(obj.prop)[0]
      ] = Object.values(obj.prop)[0];
      state.overlaysLibrary = {
        ...state.overlaysLibrary,
        images: [...state.overlaysLibrary.images],
      };
    },
    unshiftRecentImages(state, file) {
      state.recentImages = [file, ...state.recentImages];
    },
    updateRecentImages(state, obj) {
      state.recentImages.find((item) => _.isEqual(item, obj.file))[
        Object.keys(obj.prop)[0]
      ] = Object.values(obj.prop)[0];
      state.recentImages = [...state.recentImages];
    },
    deleteRecentImage(state, file) {
      state.recentImages.splice(
        state.recentImages.indexOf(
          state.recentImages.find((item) => _.isEqual(item, file))
        ),
        1
      );
      state.recentImages = [...state.recentImages];
    },
    unshiftRecentMusic(state, file) {
      state.recentMusics = [file, ...state.recentMusics];
    },
    deleteRecentMusic(state, file) {
      state.recentMusics.splice(
        state.recentMusics.indexOf(
          state.recentMusics.find((item) => _.isEqual(item, file))
        ),
        1
      );
      state.recentMusics = [...state.recentMusics];
    },
    pushVideoToOverlaysLibrary(state, file) {
      state.overlaysLibrary = {
        ...state.overlaysLibrary,
        videos: [...state.overlaysLibrary.videos, file],
      };
    },
    unshiftVideoToOverlaysLibrary(state, file) {
      state.overlaysLibrary = {
        ...state.overlaysLibrary,
        videos: [file, ...state.overlaysLibrary.videos],
      };
    },
    updateVideoInOverlaysLibrary(state, obj) {
      state.overlaysLibrary.videos.find((item) => item === obj.file)[
        Object.keys(obj.prop)[0]
      ] = Object.values(obj.prop)[0];
      state.overlaysLibrary = {
        ...state.overlaysLibrary,
        videos: [...state.overlaysLibrary.videos],
      };
    },
    pushShapeToOverlaysLibrary(state, file) {
      state.overlaysLibrary = {
        ...state.overlaysLibrary,
        shapes: [...state.overlaysLibrary.shapes, file],
      };
    },
    deleteImageFromOverlaysLibrary(state, file) {
      state.overlaysLibrary.images.splice(
        state.overlaysLibrary.images.indexOf(file),
        1
      );
      state.overlaysLibrary = {
        ...state.overlaysLibrary,
        images: [...state.overlaysLibrary.images],
      };
    },
    deleteVideoFromOverlaysLibrary(state, file) {
      state.overlaysLibrary.videos.splice(
        state.overlaysLibrary.videos.indexOf(file),
        1
      );
      state.overlaysLibrary = {
        ...state.overlaysLibrary,
        videos: [...state.overlaysLibrary.videos],
      };
    },
    deleteShapeFromOverlaysLibrary(state, file) {
      state.overlaysLibrary.shapes.splice(
        state.overlaysLibrary.shapes.indexOf(file),
        1
      );
      state.overlaysLibrary = {
        ...state.overlaysLibrary,
        shapes: [...state.overlaysLibrary.shapes],
      };
    },
    pushFileToMusicLibrary(state, file) {
      state.musicLibrary = {
        ...state.musicLibrary,
        files: [...state.musicLibrary.files, file],
      };
    },

    unshiftFileToMusicLibrary(state, file) {
      state.musicLibrary = {
        ...state.musicLibrary,
        files: [file, ...state.musicLibrary.files],
      };
    },
    deleteFileFromMusicLibrary(state, file) {
      state.musicLibrary.files.splice(
        state.musicLibrary.files.indexOf(file),
        1
      );
      state.musicLibrary = {
        ...state.musicLibrary,
        files: [...state.musicLibrary.files],
      };
    },
    setWasShownAndClosedNoticeSharpen(state, wasShownAndClosedNoticeSharpen) {
      state.userWorkParameters = {...state.userWorkParameters, wasShownAndClosedNoticeSharpen: wasShownAndClosedNoticeSharpen}
    },

    changeShadowColor(state, color) {
      state.selectedItem.currentVariation.shadow.color = color
    },
    changeShadowOpacityByStep(state, payload) {
      let currentValue = state.selectedItem.currentVariation.shadow.opacity

      if (
        payload.ascending && currentValue == 1
        || !payload.ascending && currentValue == 0
      ) {
        console.warn('Достигнут предел величины opacity')
      } else if (payload.ascending) {
        let result = ((currentValue * 100) + payload.value) / 100
        if (result > 1) {
          result = 1
        }
        state.selectedItem.currentVariation.shadow.opacity = +result.toFixed(2)
      } else {
        let result = ((currentValue * 100) - payload.value) / 100
        if (result < 0) {
          result = 0
        }
        state.selectedItem.currentVariation.shadow.opacity = +result.toFixed(2)
      }
    },
    changeShadowOpacityByNumber(state, value) {
      let result = value / 100

      state.selectedItem.currentVariation.shadow.opacity = +result.toFixed(2)
    },
    changeShadowVisibility(state) {
      state.selectedItem.currentVariation.shadow.visible =
        !state.selectedItem.currentVariation.shadow.visible
    },

    changeOpenedGridType(state, payload) {
      state.openedGridType = payload
    },
    cacheTiktokGrid: (state, payload) => {
      state.overlayGrids.tiktok = payload
    },
    cacheInstagramStoriesGrid: (state, payload) => {
      state.overlayGrids.instagramStories = payload
    },
  },
  getters: {
    isLoggedIn: (state) => state.userInfo.sessionId !== null,
    videoPreviewPixelsWidth: (state) => {
      return state.videoPreviewPixelsWidth;
    },
    //Files
    filesToUpload: (state) => {
      return state.filesToUpload;
    },
    tasksFromUAToUpload: (state) => {
      return state.tasksFromUAToUpload;
    },
    //Tables
    items: (state) => {
      return state.items;
    },
    selectedItem: (state) => {
      return state.selectedItem;
    },
    uploadToCloud: (state) => {
      return state.uploadToCloud;
    },
    //Boolean parameters
    showDownloadPanel: (state) => {
      return state.showDownloadPanel;
    },
    showRendersPreviewWindow: (state) => {
      return state.showRendersPreviewWindow;
    },
    showMusicLibraryWindow: (state) => {
      return state.showMusicLibraryWindow;
    },
    showEndCardLibraryWindow: (state) => {
      return state.showEndCardLibraryWindow;
    },
    showEndCardEditWindow: (state) => {
      return state.showEndCardEditWindow;
    },
    showStickerLibraryWindow: (state) => {
      return state.showStickerLibraryWindow;
    },
    showOverlaysLibraryWindow: (state) => {
      return state.showOverlaysLibraryWindow;
    },
    showEndCardCropImageWindow: (state) => {
      return state.showEndCardCropImageWindow;
    },
    snapshot: (state) => {
      return state.snapshot;
    },
    getImagesOverlaysLibrary: (state) => {
      return state.overlaysLibrary.images;
    },
    getRecentImages: (state) => {
      return state.recentImages;
    },
    getVideosOverlaysLibrary: (state) => {
      return state.overlaysLibrary.videos;
    },
    getShapesOverlaysLibrary: (state) => {
      return state.overlaysLibrary.shapes;
    },
    getFilesMusicLibrary: (state) => {
      return state.musicLibrary.files;
    },
    getWasShownAndClosedNoticeSharpen: (state) => {
      return state.userWorkParameters.wasShownAndClosedNoticeSharpen;
    },

    getShadowForCurrentVariation: (state) => {
      return state.selectedItem.currentVariation.shadow
    },
    getWidthOfCurrentVariation: (state) => {
      return Math.round(
        state.selectedItem.currentVariation?.previewParameters.outerVideoResolutionX *
        state.selectedItem.currentVariation?.previewParameters.userOuterVideoResolutionsDifference
      )
    },
    getHeightOfCurrentVariation: (state) => {
      return Math.round(
        state.selectedItem.currentVariation?.previewParameters.outerVideoResolutionY *
        state.selectedItem.currentVariation?.previewParameters.userOuterVideoResolutionsDifference
      )
    },
    getVideoWidthInPercent: (state) => {
      return state.selectedItem.currentVariation?.previewParameters.width
    },
    getVideoHeightInPercent: (state) => {
      return state.selectedItem.currentVariation?.previewParameters.height
    },
    getCurrentVariationZoom: (state) => {
      return state.selectedItem.currentVariation.previewParameters.zoom
    },
    getVideoDraggedOffsetYInPercent: (state) => {
      // IEEE-754 (-0)
      if (state.selectedItem.currentVariation?.previewParameters.displayVerticalShift === 0) {
        return 0
      }
      return -state.selectedItem.currentVariation?.previewParameters.displayVerticalShift
    },
    getVideoDraggedOffsetXInPercent: (state) => {
      // IEEE-754 (-0)
      if (state.selectedItem.currentVariation?.previewParameters.displayHorizontalShift === 0) {
        return 0
      }
      return -state.selectedItem.currentVariation?.previewParameters.displayHorizontalShift
    },

    getOpenedGridType: (state) => {
      return state.openedGridType
    },
    getTiktokGridConfiguration: (state) => {
      return state.overlayGrids.tiktok
    },
    getInstagramStoriesGridConfiguration: (state) => {
      return state.overlayGrids.instagramStories
    },
  },
  actions: {
    fetchTikTokOverlayGrid: async (context) => {
      let url = process.env.NODE_ENV === "production"
        ? "https://creative.roasup.com"
        : "https://rsz-dev.roasup.com"

      await axios.get(url + "/media/adv-net/tiktok.json")
        .then((response) => {
          context.commit('cacheTiktokGrid', response.data)
        })
    },
    fetchInstagramStoriesGrid: async (context) => {
      let url = process.env.NODE_ENV === "production"
        ? "https://creative.roasup.com"
        : "https://rsz-dev.roasup.com"

      await axios.get(url + '/media/adv-net/instagram.json')
        .then((response) => {
          context.commit('cacheInstagramStoriesGrid', response.data)
        })
    },
  },
});
